import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "../../components-shadcn/ui/toast";
import { useToast } from "../../components-shadcn/ui/use-toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="tw-grid tw-gap-1">
              {title && (
                <ToastTitle
                  className={`tw-rounded-md tw-w-[80px] tw-h-[28px] tw-text-center tw-pt-1 ${
                    props.variant === "destructive"
                      ? "tw-bg-[#ff392b]"
                      : "tw-bg-[#00e6a0]"
                  }`}
                >
                  {title}
                </ToastTitle>
              )}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
